import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';

import { EmptyTitleComponent } from './EmptyTitleComponent';

const EmptyPurchased = () => {
  const { t } = useTranslation();

  return (
    <div className="page-empty">
      <img
        src={company.images.order.empty}
        className="page-empty__image"
        alt=""
      />

      <EmptyTitleComponent className="text-center">
        {t('phrases:emptyPurchased')}
      </EmptyTitleComponent>
    </div>
  );
};

export default EmptyPurchased;
